import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ChooseNumber } from 'pages/settings/pages/numbers/pages/BuyNumber/ui/ChooseNumber/ChooseNumber'
import { BuyNumberRoutes } from 'pages/settings/pages/numbers/pages/BuyNumber/route/type'
import { BuyNumberStepsLayout } from 'pages/settings/pages/numbers/pages/BuyNumber/layout/buyNumberLayout'
import { AssignNumber } from 'pages/settings/pages/numbers/pages/BuyNumber/ui/AssignNumber/AssignNumber'
import { Payment } from 'pages/settings/pages/numbers/pages/BuyNumber/ui/Payment/Payment'
import { BuyNumberProviderLayout } from 'pages/settings/pages/numbers/pages/BuyNumber/layout/buyNumberProviderLayoutContent'
import { BuyNumberAccessLayout } from 'pages/settings/pages/numbers/pages/BuyNumber/layout/buyNumberAccessLayout'

export const BuyNumberStepsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<BuyNumberAccessLayout />}>
        <Route element={<BuyNumberProviderLayout />}>
          <Route path={BuyNumberRoutes.steps} element={<BuyNumberStepsLayout />}>
            <Route path={BuyNumberRoutes.chooseNumber} element={<ChooseNumber />} />
            <Route path={BuyNumberRoutes.assignNumber} element={<AssignNumber />} />
            <Route path={BuyNumberRoutes.payment} element={<Payment />} />
          </Route>
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
